import SignITLogo from "./logos/SignIT.png";
import TriSignLogo from "./logos/triSign.png";

type DigitalSignatureLogoProps = {
  variant: "signit" | "trisign";
  className?: string;
};

export const DigitalSignatureLogo = ({
  variant,
  className,
}: DigitalSignatureLogoProps) => {
  const logo = variant === "signit" ? SignITLogo : TriSignLogo;
  const logoAlt = variant === "signit" ? "SignIT Logo" : "triSign Logo";
  return <img src={logo} alt={logoAlt} className={className} />;
};
